import React, {FC} from 'react';
import styled, {css} from 'styled-components';

import {fontSizes} from '../../../../../../../libs/shared/ui/src/styles/fontStyles';
import {textSelection} from '../../../../../../../libs/shared/ui/src/styles/mixins';
import {LoadedMessageModel} from '../../../../../../models/api/messageModel';
import {TimelineVariationsEnum} from '../../../../../../store/timelineVariations/timelineVariationSelectors';
import {AnnotationsHighlightViewerInheritableProps} from '../../../../../common/annotation/annotationsHighlightViewer';
import {AnnotationsHighlightViewerContainer} from '../../../../../common/annotation/annotationsHighlightViewerContainer';
import {MessageViewerBody} from '../messageViewerBody';

/*
 * Props.
 */

export interface MessageViewerChatBodyProps extends AnnotationsHighlightViewerInheritableProps {
  message: LoadedMessageModel;
  isUserVisitor: boolean;
  className?: string;
  timelineVariation: TimelineVariationsEnum;
  isInbound?: boolean;
}

/*
 * Style.
 */

interface StyledChatDivProps {
  $timelineVariation: TimelineVariationsEnum;
}
const StyledChatDiv = styled.div<StyledChatDivProps>`
  ${textSelection()};

  color: ${(p) => p.theme.greys.shade80};
  font-size: ${fontSizes.medium};

  ${(p) => addChatDivStyles(p.$timelineVariation)}

  .front-inline-img {
    max-width: 60%;
    height: auto;
  }
`;
const addChatDivStyles = ($timelineVariation: TimelineVariationsEnum) =>
  $timelineVariation === TimelineVariationsEnum.SYNCHRONOUS
    ? css`
        padding: 8px 12px;
        max-width: 500px;
        line-height: 20px;
      `
    : css`
        padding: 12px 16px;
        line-height: 22px;
      `;

/*
 * Component.
 */

export const MessageViewerChatBody: FC<MessageViewerChatBodyProps> = (props) => (
  <AnnotationsHighlightViewerContainer
    annotations={props.annotations}
    onQuoteInCommentClick={props.onQuoteInCommentClick}
    hasMessageAnnotations={props.hasMessageAnnotations}
    panelId={props.panelId}
    conversationId={props.message.conversationId}
  >
    <StyledChatDiv className={props.className} $timelineVariation={props.timelineVariation}>
      <MessageViewerBody
        {...props}
        body={props.message.body}
        messageId={props.message.id}
        attachments={props.message.attachments}
        isExternalContentHidden={false}
        isUserVisitor={props.isUserVisitor}
        onQuoteInCommentClick={props.onQuoteInCommentClick}
        timelineVariation={props.timelineVariation}
        isInbound={props.isInbound}
      />
    </StyledChatDiv>
  </AnnotationsHighlightViewerContainer>
);
